import { createFileRoute, notFound } from "@tanstack/react-router";
import NotFound from "@/pages/NotFound";

export const Route = createFileRoute("/_app/$")({
  // Unknown addresses must answer with a real 404 status, not a soft 404.
  loader: () => {
    throw notFound();
  },
  head: () => ({
    meta: [{ title: "Page Not Found" }, { name: "robots", content: "noindex" }],
  }),
  notFoundComponent: NotFound,
  component: NotFound,
});
